// extracted by mini-css-extract-plugin
export default {"input":"EditableTextField_input__XYp92","titleInput":"EditableTextField_titleInput__zyRhY"};